<template>
	<div class="batch-import-task-page page-layout">
		<gc-header headerData="batchImportTask">
			<template #ops>
				<el-button v-has="'monitor:imei:batch:insert'" type="primary" @click="handleShowTaskModal">
					创建任务
				</el-button>
			</template>
		</gc-header>
		<div class="run-main">
			<div class="serach">
				<gc-advanced-filter
					v-model="form"
					:fields="filterFields"
					@search="handleQuerySearch"
					@reset="handleQueryReset"
				/>
				<gc-column-setting
					storageKey="localcolumn-batch-import-task"
					:columns="columns"
					@update-column="data => (columns = data)"
				></gc-column-setting>
			</div>
			<div class="table-show" v-loading="loading">
				<gc-table
					border
					showPage
					:columns="columnList"
					:table-data="tableData"
					:current-page.sync="pagination.currentPage"
					:total="pagination.total"
					:pageSize="pagination.pageSize"
					gloabSortDisable
					@current-page-change="handleCurrentPageChange"
					@size-change="handlePageSizeChange"
				></gc-table>
			</div>
		</div>

		<!-- 任务创建弹窗 -->
		<TaskModal
			v-if="taskModalVisible"
			:deviceGroupOptions="deviceGroupOptions.filter(m => m.status === 1)"
			@close-modal="handleCloseModal"
		/>

		<!-- 取消任务弹窗 -->
		<CancelTaskModal v-if="cancelModelVisible" :taskId="currentTaskId" @close-modal="handleCloseModal" />
	</div>
</template>

<script>
import { apiGetDeviceGroupPageList, apiGetDeviceImeiRegistTaskList } from '@/apis/communicationModelManage.api'
import { apiManufacturerList } from '@/apis/factory.api'
import {
	MODULE_TASK_STATUS_OPTIONS,
	MODULE_BATCH_TASK_TYPE_OPTIONS,
	MODULE_BATCH_TASK_TYPE_OPTIONS_MAP,
	MODULE_TASK_STATUS_MAP,
} from '@/config/const'
import TaskModal from './components/TaskModal'
import CancelTaskModal from './components/CancelTaskModal'

export default {
	name: 'batchTask',
	components: { TaskModal, CancelTaskModal },
	data() {
		return {
			MODULE_BATCH_TASK_TYPE_OPTIONS,
			MODULE_TASK_STATUS_OPTIONS,
			form: {
				taskName: null,
				manufacturerId: null,
				deviceGroupId: null,
				taskStatus: null,
				operationType: null,
			},
			columns: [
				{
					key: 'taskName',
					name: '任务名称',
					tooltip: true,
					dragDisable: true,
					disabledSelect: true,
					minWidth: 180,
					fixed: 'left',
				},
				{
					key: 'deviceGroupName',
					name: '设备组',
					tooltip: true,
					minWidth: 200,
				},
				{
					key: 'operationType',
					name: '操作类型',
					minWidth: 180,
					render: (h, row) => {
						return h('span', null, MODULE_BATCH_TASK_TYPE_OPTIONS_MAP[row.operationType] || '--')
					},
				},
				{
					key: 'taskStatus',
					name: '任务状态',
					minWidth: 180,
					render: (h, row) => {
						const classMap = {
							0: 'dot-message',
							1: 'dot-message',
							2: 'dot-message',
							3: 'dot-success',
							4: 'dot-error',
						}
						return h('span', { class: classMap[row.taskStatus] }, MODULE_TASK_STATUS_MAP[row.taskStatus])
					},
				},
				{
					key: 'waitCount',
					name: '前方排队数',
				},
				{
					key: 'importTotal',
					name: '导入总数',
				},
				{
					key: 'pendingCount',
					name: '待执行数',
				},
				{
					key: 'successCount',
					name: '成功数',
				},
				{
					key: 'failureCount',
					name: '失败数',
				},
				{
					key: 'createStaffName',
					name: '创建人',
				},
				{
					key: 'createTime',
					name: '创建时间',
					minWidth: 180,
					tooltip: true,
				},
				{
					key: 'remark',
					name: '备注',
					tooltip: true,
				},
				{
					key: 'oprate',
					name: '操作',
					sortDisable: true,
					width: 100,
					fixed: 'right',
					render: (h, row) => {
						return h('div', {}, [
							h(
								'el-button',
								{
									props: {
										type: 'text',
										size: 'medium',
									},
									on: {
										click: () => {
											this.$router.push({
												path: '/communication-model-manage/batch-task-details',
												query: {
													taskId: row.taskId,
												},
											})
										},
									},
								},
								'详情',
							),
							row.taskStatus === 0 && this.$has('monitor:imei:batch:update')
								? h(
										'el-button',
										{
											style: { color: '#e5662e' },
											props: {
												type: 'text',
												size: 'medium',
											},
											on: {
												click: () => {
													this.currentTaskId = row.taskId
													this.cancelModelVisible = true
												},
											},
										},
										'取消',
								  )
								: null,
						])
					},
				},
			],
			pagination: {
				currentPage: 1,
				pageSize: 20,
				total: 0,
			},
			tableData: [],
			loading: false,
			taskModalVisible: false,
			cancelModelVisible: false,
			currentTaskId: null,
			deviceGroupOptions: [],
			manufacturerListOptions: [],
		}
	},
	created() {
		this.queryDeviceGroupPageList()
		this.queryBatchImportTaskList()
		this.queryManufacturerList()
	},

	methods: {
		async queryDeviceGroupPageList() {
			const data = await apiGetDeviceGroupPageList({
				manufacturerId: this.manufacturerId,
				current: 1,
				size: 10000,
			})
			this.deviceGroupOptions = (data.records || []).sort((x, y) => y.status - x.status)
		},

		async queryManufacturerList() {
			const data = await apiManufacturerList({ current: 1, size: 1000 })
			this.manufacturerListOptions = (data.records || []).map(m => {
				return {
					value: m.manufacturerId,
					label: m.manufacturerName,
				}
			})
		},

		async queryBatchImportTaskList() {
			this.loading = true
			const searchParams = {
				...this.form,
				manufacturerId: this.form.manufacturerId || this.manufacturerId,
				current: this.pagination.currentPage,
				size: this.pagination.pageSize,
			}
			try {
				const { records = [], total } = await apiGetDeviceImeiRegistTaskList(searchParams)
				this.tableData = records
				this.pagination.total = total
			} finally {
				this.loading = false
			}
		},

		handleCurrentPageChange(current) {
			this.pagination.currentPage = current
			this.queryBatchImportTaskList()
		},

		handlePageSizeChange(size) {
			this.pagination.currentPage = 1
			this.pagination.pageSize = size
			this.queryBatchImportTaskList()
		},

		handleQuerySearch() {
			this.pagination.currentPage = 1
			this.queryBatchImportTaskList()
		},

		handleQueryReset() {
			for (const key in this.form) {
				this.form[key] = null
			}
			this.pagination.currentPage = 1
			this.queryBatchImportTaskList()
		},

		handleCloseModal(refresh) {
			this.taskModalVisible = false
			this.cancelModelVisible = false
			if (refresh) {
				this.handleQuerySearch()
			}
		},

		handleShowTaskModal() {
			this.taskModalVisible = true
		},
	},

	computed: {
		columnList() {
			return this.columns.filter(o => o.selected)
		},

		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},

		manufacturerId() {
			return this.$store.getters.userInfo.manufacturerId
		},

		filterFields() {
			return [
				{ prop: 'taskName', label: '任务名称', type: 'input' },
				{
					prop: 'deviceGroupId',
					label: '设备组',
					type: 'select',
					props: {
						searchOption: this.deviceGroupOptions,
						needAllForSearch: true,
						searchOptionKey: { label: 'deviceGroupName', value: 'id' },
					},
				},
				{
					prop: 'taskStatus',
					label: '任务状态',
					type: 'select',
					props: {
						searchOption: this.MODULE_TASK_STATUS_OPTIONS,
						needAllForSearch: true,
					},
				},
				{
					prop: 'manufacturerId',
					label: '厂商',
					type: 'select',
					props: {
						searchOption: this.manufacturerListOptions,
						needAllForSearch: true,
						filterable: true,
					},
					hidden: this.manufacturerId !== 0,
				},
				{
					prop: 'operationType',
					label: '操作状态',
					type: 'select',
					props: {
						searchOption: this.MODULE_BATCH_TASK_TYPE_OPTIONS,
						needAllForSearch: true,
					},
				},
			].filter(item => !item.hidden)
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../../run-manage/runLayout.scss';
</style>
